export const classs =[
    {value : "All Class"},
    {value : "Sleeper Class"},
    {value : "Third AC"},
    {value : "Second AC"},
    {value : "First AC"},
    {value : "Second Seating"},
    {value : "Vistadome AC"},
    {value : "AC Chair Car"}
]

export const liveTrainStatus=[
    {
        number:'14722',
        name:'Abohar Jodhpur Express'
    },
    {
        number:'02502',
        name:'Agartala Kolkata Special'
    },
    {
        number:'12231',
        name:'Lucknow Chandigarh SF Express'
    },
    {
        number:'12565',
        name:'Bihar Sampark Kranti Express'
    },
    {
        number:'12528',
        name:'Ramnagar Weekly SF Express'
    },
    {
        number:'15011',
        name:'Chandigarh Express'
    },
    {
        number:'14616',
        name:'Lalkuan Express'
    },
    {
        number:'09417',
        name:'Ahmedabad Patna Special'
    },
    {
        number:'04302',
        name:'Saharanpur Moradabad Express'
    },
    {
        number:'14650',
        name:'Saryu Yamuna Express'
    },
    {
        number:'15120',
        name:'Dehradun Banaras Express'
    },
]